import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
    earlyAccess: false,
    internalUser: false,
    mobileUnitAdmin: false,
};

const userSlice = createSlice({
    name: "user",
    initialState: INITIAL_STATE,
    reducers: {
        setEarlyAccess(state, action) {
            return {
                ...state,
                earlyAccess: action.payload,
            };
        },
        setInternalUser(state, action) {
            return {
                ...state,
                internalUser: action.payload,
            };
        },
        setMobileUnitAdmin(state, action) {
            return {
                ...state,
                mobileUnitAdmin: action.payload,
            };
        },
    },
});

export const userActions = userSlice.actions;

export default userSlice;
